import SoapRanapStore from "@/store/modules/SoapRanapStore";
import CpptRanapStore from "@/store/modules/CpptRanapStore";
import { isHemodialisa, isRalan } from "@/utils/unit";

export interface CpptEntry {
  type: string;
  data: any;
  examined_at: string;
}

export type VerifikasiMode = "ranap" | "ralan";

export function isUnitVerifResiden(unitId: string | null | undefined): boolean {
  return isRalan(unitId) || isHemodialisa(unitId);
}

export function dpjpBolehVerifSoap(
  soap: any,
  user: any,
  dpjpId: number | string | null | undefined
): boolean {
  if (!soap || !user || dpjpId == null || user.id != dpjpId) return false;
  if (user.id == soap.user_id) return false;
  return (
    !isUnitVerifResiden(soap.unit_id) ||
    soap.penulis_residen_internship === true
  );
}

export function buildCpptList(user: any): CpptEntry[] {
  const soap: CpptEntry[] = SoapRanapStore.soapList.map(it => ({
    type: "soap",
    data: it,
    examined_at: it.examined_at
  }));
  const adime: CpptEntry[] = CpptRanapStore.adimeList.map(it => ({
    type: "adime",
    data: it,
    examined_at: it.examined_at
  }));
  const readback: CpptEntry[] = CpptRanapStore.readbackList.map(it => ({
    type: "readback",
    data: it,
    examined_at: it.consulting_at
  }));
  const handover: CpptEntry[] = !user.isMedis
    ? CpptRanapStore.handoverList.map(it => ({
        type: "handover",
        data: it,
        examined_at: it.transferred_at
      }))
    : [];

  return [...soap, ...adime, ...readback, ...handover].sort(
    (a, b) =>
      new Date(b.examined_at).getTime() - new Date(a.examined_at).getTime()
  );
}

function isSbarDraft(data: any): boolean {
  return data?.format === "sbar" && !data?.responded_at;
}

export function filterCpptForVerif(
  list: CpptEntry[],
  user: any,
  isDpjp: boolean,
  mode: VerifikasiMode = "ranap"
): CpptEntry[] {
  let filtered: CpptEntry[] = [];

  if (mode === "ralan") {
    filtered = isDpjp
      ? list.filter(
          cppt =>
            cppt.type === "soap" &&
            !cppt.data.verified_at &&
            dpjpBolehVerifSoap(cppt.data, user, user.id)
        )
      : [];
  } else if (isDpjp) {
    filtered = list.filter(cppt => {
      const data = cppt.data;
      if (cppt.type === "soap") {
        return !data.verified_at && dpjpBolehVerifSoap(data, user, user.id);
      }
      if (cppt.type === "adime") {
        return !data.verified_at && data.user_id != user.id;
      }
      if (cppt.type === "readback") {
        if (isSbarDraft(data)) {
          return false;
        }
        return (
          (data.consultant_verified_at &&
            !data.dpjp_verified_at &&
            data.dpjp_user_id != user.id) ||
          (data.consultant_user_id == user.id && !data.consultant_verified_at)
        );
      }
      return false;
    });
  } else if (user.isMedis) {
    filtered = list.filter(cppt => {
      const data = cppt.data;
      return (
        cppt.type === "readback" &&
        !isSbarDraft(data) &&
        data.consultant_user_id == user.id &&
        !data.consultant_verified_at
      );
    });
  } else {
    filtered = list.filter(cppt => {
      const data = cppt.data;
      return (
        cppt.type === "handover" &&
        data.to_user_id == user.id &&
        !data.approved_at
      );
    });
  }

  return filtered.sort(
    (a, b) =>
      new Date(a.examined_at).getTime() - new Date(b.examined_at).getTime()
  );
}

export async function fetchCpptSources(
  registerId: number,
  user: any,
  mode: VerifikasiMode = "ranap"
): Promise<void> {
  if (mode === "ralan") {
    await SoapRanapStore.getByRegister(registerId);
  } else if (user.isMedis) {
    await SoapRanapStore.getByRegister(registerId);
    await CpptRanapStore.getAdimeByRegister(registerId);
    await CpptRanapStore.getReadbackByRegister(registerId);
  } else {
    await CpptRanapStore.getHandoverByRegister(registerId);
  }
}

export function canVerifCppt(user: any): boolean {
  return parseInt(user?.cdoc?.idsp) > 0 || !user.isMedis;
}
